import { HttpClient, HttpContextToken, HttpRequest, HttpResponseBase } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { Observable } from 'rxjs';
import { Lookup, PagedResults, PagerOptions } from 'src/app/app.types';
import { stringifyPagerOptions } from '../../../util/http-helpers';
import { GENERIC_ERROR_SUPPRESSION_TOKEN } from 'src/app/app.module';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LookupService {

  constructor(private http: HttpClient,
      private configService: ConfigService,
      @Inject(GENERIC_ERROR_SUPPRESSION_TOKEN) private suppressGenericErrorToken: HttpContextToken<boolean>) { }

  getList(controllerName: string, pagerOptions: PagerOptions): Observable<PagedResults<Lookup>>{
    if(!controllerName){
      console.error("controller name not set!");
      return;
    }

    const url = `${this.createApiUrl(controllerName)}/${stringifyPagerOptions(pagerOptions)}`;

    return this.http.get<PagedResults<Lookup>>(url);
  }

  addNew(controllerName: string, lookup: Lookup){
    if(!controllerName){
      console.error("controller name not set!");
      return;
    }

    const req = new HttpRequest("POST", this.createApiUrl(controllerName), lookup);

    return this.http.request<Lookup>(req)
      .pipe(filter(x => x instanceof HttpResponseBase));
  }

  edit(controllerName: string, lookup: Lookup){
    if(!controllerName){
      console.error("controller name not set!");
      return;
    }

    const req = new HttpRequest("PUT", `${this.createApiUrl(controllerName)}/${lookup.id}`, lookup);

    req.context.set(this.suppressGenericErrorToken, true);

    return this.http.request<Lookup>(req)
      .pipe(filter(x => x instanceof HttpResponseBase));
  }

  delete(controllerName: string, lookup: Lookup){
    if(!controllerName){
      console.error("controller name not set!");
      return;
    }

    const req = new HttpRequest("DELETE", `${this.createApiUrl(controllerName)}/${lookup.id}`);

    return this.http.request<Lookup>(req)
      .pipe(filter(x => x instanceof HttpResponseBase));
  }

  createApiUrl(controllerName: string): string {
    return `${this.configService.API_URI}/${controllerName}` ;
  }
}
